<template>
  <div @click="clickCheck" class="pointer">
    <div class="left mr-2">
      <font-awesome-icon
        v-if="!check"
        class="f20 pointer color-primary-dark"
        :icon="['far', 'square']"
      />
      <font-awesome-icon
        v-if="check"
        class="f20 pointer color-primary-dark"
        :icon="['far', 'check-square']"
      />
    </div>
    <span>{{label}}</span>
  </div>
</template>

<script>
export default {
  props: ["id", "checked", "label", "index"],
  data: () => ({
    check: false,
  }),
  mounted() {
    if (this.checked) this.check = this.checked;
    eventBus.$on("no_check", (field) => {
      this.check = false;
    });
  },
  methods: {
    clickCheck() {
      this.check = !this.check;
      eventBus.$emit("checkbox", {
        id: this.id,
        operator: this.check,
        index: this.index,
      });
    },
  },
};
</script>
